import ManageSocieteForfaitaire from '@/components/comptable/creance/creance-forfaitaire/manage-forfait'
import store_assurance from '@/store/mods/parametres/assurance'
import $ from 'jquery'

export default {
    name: 'societes-forfaitaires',
    components: {
        ManageSocieteForfaitaire
    },
    props: {
        user_info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_error: false,
            liste_assur_souscripteurs: [],

            fields: [
                { key: 'chk', label: '' },
                { key: 'societe', label: 'Société' },  
                { key: 'prix_unitaire_forfait', label: 'P.U.' },
                { key: 'qte', label: 'Qté' },
                { key: 'montant_forfait', label: 'P.T' },
                // { key: 'action', label: 'Action.s' }
            ],
           
            filter: [],
            perPage: -1,
            currentPage: 1,
            action_toggler: 0,
            societe_action_toggler: 0,
            action_data_type: '',

            liste_assurances: [],
            selected_assurance: {},
            selected_societes: [],

            checked_assurances: [],
            checked_societes: [],
            all_checked: false,
            selected_facture: {
                assurance_id: '',
                assurance: '',
                souscripteur_id: 0,
                souscripteur: '',
                sum_part_assureur: 0,
                reference: '',
                date: '',
                mois: '',  
                annee: '',
                info_complementaire: {}
            }
        }
    },

    watch: {
        selected_assurance() {
            if (this.selected_assurance.id == 0) {
                $('.all-assur').fadeIn(200)
            } else {
                this.showHideAsssurances()
            }
        }
    },

    computed: {

    },

    mounted() {
        this.fields = [
            { key: 'chk', label: '' },
            { key: 'societe', label: 'Société' },  
            { key: 'prix_unitaire_forfait', label: 'P.U. en '+this.currency_info.principal_currency },
            { key: 'qte', label: 'Qté' },
            { key: 'montant_forfait', label: 'P.T. en '+this.currency_info.principal_currency },
            // { key: 'action', label: 'Action.s' }
        ]

        this.fetchSouscripteurs()
    },

    methods: {
        showHideAsssurances() {
            $('.all-assur').fadeOut(200)

            setTimeout(() => {
                $('.s-assur-'+this.selected_assurance.id).fadeIn(100)
            }, 300);
        },

        fetchSouscripteurs() {
            this.is_loading = true
            this.is_error = false

            const data = {
                a_model_forfait: 1
            }
            store_assurance.getSouscripteurGroupByAssurance(data).then((response) => {
                this.liste_assur_souscripteurs = response
                
                for (let i = 0; i < this.liste_assur_souscripteurs.length; i++) {
                    this.filter[i] = ''
                }

                if (this.liste_assur_souscripteurs.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
                this.setListeAssurances()
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        setListeAssurances() {
            this.liste_assurances = []
            let tmp_assur = {
                id: 0,
                libelle: "Toutes les assurances"
            }
            this.selected_assurance = tmp_assur
            this.liste_assurances.push(tmp_assur)

            this.liste_assur_souscripteurs.forEach(el => {
                let tmp_assur = {
                    id: el.assurance_id,
                    libelle: el.raison_sociale
                }
                this.liste_assurances.push(tmp_assur)
            });
        },

        toutSelectionner() {
            let is_checked = $('#all-assur').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.checked_societes = []
            this.checked_assurances = []

            
            this.liste_assur_souscripteurs.forEach((assurance) => {
                if (is_checked) {
                    this.checked_assurances.push(assurance.assurance_id)
                }

                assurance.souscripteurs.forEach((_data) => {
                    if (is_checked ) {
                        this.checked_societes.push(_data.souscripteur_id)
                    }
                })
            });
            
            this.all_checked = is_checked
        },

        touteAssurances(index) {
            let is_checked = $('#f-assur-'+index).is(":checked")

            this.toggleAssuranceChecked(is_checked, index)
        },

        toggleAssuranceChecked(is_checked, index) {
            this.liste_assur_souscripteurs.forEach((assurance) => {
                if (assurance.assurance_id == index) {
                    if (is_checked) {
                        assurance.souscripteurs.forEach((_data) => {
                            let index_of = this.checked_societes.indexOf(_data.souscripteur_id)
                            if (index_of > -1) {
                                this.checked_societes.splice(index_of, 1)
                            }
                        })
                    }
                    assurance.souscripteurs.forEach((_data) => {
                        if (is_checked) {
                            this.checked_societes.push(_data.souscripteur_id)
                        } else {
                            let index_of = this.checked_societes.indexOf(_data.souscripteur_id)
                            if (index_of > -1) {
                                this.checked_societes.splice(index_of, 1)
                            }
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },

        async setSocietesAdeposer() {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.selected_societes = []
            await this.liste_assur_souscripteurs.forEach((assurance) => {
                assurance.souscripteurs.forEach((_data) => {
                    this.checked_societes.forEach(societe_id => {
                        if (_data.souscripteur_id == societe_id) {
                            const tmp_soc = {
                                souscripteur_id: _data.souscripteur_id,
                                souscripteur: _data.souscripteur,
                                pu_initial: _data.prix_unitaire_forfait,
                                pu: _data.prix_unitaire_forfait,
                                qte_initiale: _data.qte_forfait,
                                qte: _data.qte_forfait,
                                montant: _data.montant_forfait,
                                prefixe: _data.prefixe_reference_facture
                            }
                            this.selected_societes.push(tmp_soc)
                        }
                    });
                })
            });
            $('.dep-fac-soc').modal('show')
        },

        redirectToFacture() {
            this.$emit('emitForfaitView') 
        }
    }
}